import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { ProducerType } from '../../types/producer.type'

@Component({
  selector: 'bmcore-follow-beatmaker-block',
  templateUrl: './bmcore-follow-beatmaker-block.component.html',
  styleUrls: ['./bmcore-follow-beatmaker-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreFollowBeatmakerBlockComponent implements OnInit {
  @Input() producer: ProducerType

  constructor() {}

  ngOnInit(): void {}
}
